import { withMotion } from '@hoc/withMotion';
import useScrollLock from '@hooks/useBodyScrollLock';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import SiteWide from '@stories/Components/Global/SiteWide/SiteWide';
import SearchField from '@stories/Components/Header/SearchField/SearchField';
import Navigation from '@stories/Components/Navigation/Navigation';
import NavigationMobile from '@stories/Components/Navigation/NavigationMobile/NavigationMobile';
import React, { useState } from 'react';
import HeaderStyles from './Header.styles';
const Header = ({ logInCta = undefined, logo, navigation = [], personalisedNavigation = [], searchResultsPlaceholder, searchResultsUrl = '/', signUpCta, topLinks = undefined, isCampaignPage = false, }) => {
    const ref = React.useRef(null);
    const [showSearchMobile, setShowSearchMobile] = useState(false);
    const [openMenu, setOpenMenu] = useState(false);
    const [usePersonalisedMenu, setUsePersonalisedMenu] = useState(!!personalisedNavigation);
    const [activeMobileNavigationId, setActiveMobileNavigationId] = useState('');
    useScrollLock(ref.current, openMenu);
    return (React.createElement(HeaderStyles.Container, null,
        React.createElement(SiteWide, null,
            React.createElement(HeaderStyles.Grid, { hasTopLinks: topLinks ? true : false },
                searchResultsUrl && (React.createElement(HeaderStyles.SearchArea, null,
                    React.createElement(HeaderStyles.ShowSearch, { type: 'button', onClick: () => setShowSearchMobile(true) },
                        React.createElement(HeaderStyles.SearchIcon, null)),
                    React.createElement(SearchField, { searchResultsPlaceholder: searchResultsPlaceholder, searchResultsUrl: searchResultsUrl, showSearchMobile: showSearchMobile, onClose: () => {
                            setShowSearchMobile(false);
                        } }))),
                React.createElement(HeaderStyles.LogoArea, null, logo && (React.createElement(HeaderStyles.HomeLink, { href: logo.url },
                    React.createElement(HeaderStyles.Logo, { alt: logo.title, loading: 'lazy', src: logo.icon })))),
                React.createElement(HeaderStyles.CtaArea, null,
                    React.createElement(HeaderStyles.CtaInner, null,
                        topLinks && topLinks?.length > 0 && (React.createElement(HeaderStyles.TopLinkHolder, null,
                            React.createElement(HeaderStyles.TopLinkList, null, topLinks.map(link => (React.createElement(HeaderStyles.TopLinkItem, { key: link.text, href: link.url, target: link.target }, link.text)))))),
                        React.createElement(HeaderStyles.CtaHolder, null,
                            logInCta && (React.createElement(LinkButton, { themeOption: logInCta?.themeOption, title: logInCta?.text, href: logInCta?.url, target: logInCta?.target })),
                            signUpCta && (React.createElement(LinkButton, { themeOption: signUpCta?.themeOption, title: signUpCta?.text, href: signUpCta?.url, target: signUpCta?.target })))),
                    React.createElement(HeaderStyles.MobileMenuBtn, { type: 'button', openMenu: openMenu, onClick: () => setOpenMenu(!openMenu) },
                        React.createElement(HeaderStyles.MobileBtnBar, null),
                        React.createElement(HeaderStyles.MobileBtnBar, null),
                        React.createElement(HeaderStyles.MobileBtnBar, null))))),
        !isCampaignPage && (React.createElement(Navigation, { items: usePersonalisedMenu ? personalisedNavigation : navigation, canPersonalise: !!personalisedNavigation, isPersonalised: usePersonalisedMenu, onPersonalise: () => setUsePersonalisedMenu(!usePersonalisedMenu) })),
        !isCampaignPage && (React.createElement(HeaderStyles.MobileNavHolder, { ref: ref, active: openMenu, initial: 'hidden', animate: openMenu ? 'visible' : 'hidden', variants: {
                hidden: {
                    opacity: 0,
                    transitionEnd: {
                        visibility: 'hidden',
                        transform: 'translateX(-100%)',
                    },
                    transition: {
                        type: 'tween',
                        ease: 'easeOut',
                    },
                },
                visible: {
                    opacity: 1,
                    visibility: 'visible',
                    transform: 'translateX(0)',
                    transition: {
                        type: 'tween',
                        ease: 'easeOut',
                    },
                },
            } },
            React.createElement(NavigationMobile, { activeId: activeMobileNavigationId, items: usePersonalisedMenu ? personalisedNavigation : navigation, logInCta: logInCta, onItemClick: id => setActiveMobileNavigationId(id), signUpCta: signUpCta, topLinks: topLinks, canPersonalise: !!personalisedNavigation, isPersonalised: usePersonalisedMenu, onPersonalise: () => setUsePersonalisedMenu(!usePersonalisedMenu) })))));
};
export default withMotion(Header);
